import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/AuthLayout';
import DashboardLayout from './layouts/DashboardLayout';
import '@questlabs/react-sdk/dist/style.css';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import CandidateDashboard from './pages/CandidateDashboard';
import Analytics from './pages/Analytics';
import Positions from './pages/Positions';
import Applications from './pages/Applications';
import ApplicationWorkflow from './pages/ApplicationWorkflow';
import Candidates from './pages/Candidates';
import CandidateProfile from './pages/CandidateProfile';
import Staff from './pages/Staff';
import Content from './pages/Content';
import Pages from './pages/Pages';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import CandidateFeedback from './pages/Feedback';
import Notifications from './pages/Notifications';
import ScoreInsights from './pages/ScoreInsights';
import ProfileReviews from './pages/ProfileReviews';
import InterviewFeedback from './pages/InterviewFeedback';
import CandidateCommunication from './pages/CandidateCommunication';

// New HRIS Pages
import MarineCrew from './pages/MarineCrew';
import Immigration from './pages/Immigration';
import Employees from './pages/Employees';
import LeaveManagement from './pages/LeaveManagement';
import Performance from './pages/Performance';
import Benefits from './pages/Benefits';
import Training from './pages/Training';
import EmployeeDashboard from './pages/EmployeeDashboard';
import JobTracker from './pages/JobTracker';
import InternalJobs from './pages/InternalJobs';
import MyCertificates from './pages/MyCertificates';
import MyApplications from './pages/MyApplications';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Route>
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/leave" element={<LeaveManagement />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/training" element={<Training />} />
          <Route path="/positions" element={<Positions />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/workflow" element={<ApplicationWorkflow />} />
          <Route path="/candidates" element={<Candidates />} />
          <Route path="/candidates/:id" element={<CandidateProfile />} />
          <Route path="/marine-crew" element={<MarineCrew />} />
          <Route path="/immigration" element={<Immigration />} />
          <Route path="/job-tracker" element={<JobTracker />} />
          <Route path="/internal-jobs" element={<InternalJobs />} />
          <Route path="/my-certificates" element={<MyCertificates />} />
          <Route path="/my-applications" element={<MyApplications />} />
          <Route path="/jobs" element={<CandidateDashboard />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/score-insights" element={<ScoreInsights />} />
          <Route path="/profile-reviews" element={<ProfileReviews />} />
          <Route path="/interview-feedback" element={<InterviewFeedback />} />
          <Route path="/communication" element={<CandidateCommunication />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/feedback" element={<CandidateFeedback />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/content" element={<Content />} />
          <Route path="/pages" element={<Pages />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;